import React from 'react'
import TicketHeader from './TicketHeader '
import TicketForm from './TicketForm '
import DocumentTabs from './DocumentTabs '

const MainClientTicket = () => {
  return (
    <div className='p-4 space-y-5'>
      <TicketHeader />
      <TicketForm />
      <DocumentTabs />
    </div>
  )
}

export default MainClientTicket